import React, { FC, useMemo } from 'react';

import dayjs from 'dayjs';

import { TableContainer } from '@mui/material';
import Table from 'molecules/Table';
import { StyledCellText2 } from 'molecules/Table/styles/Text.styles';
import { ICompanyDeal } from 'organisms/CompanyDetailsCard/index';
import { neutrals } from 'utils/styles/color';

const CompanyDeals: FC<{
  deals: ICompanyDeal[];
}> = ({ deals }) => {
  const columns = useMemo(
    () => [
      {
        key: 'sales_rep_name',
        label: 'Sales Rep name',
        sortable: false,
        width: '25%',
        render: ({ sale_rep_name }: ICompanyDeal) => (
          <StyledCellText2>{sale_rep_name}</StyledCellText2>
        ),
      },
      {
        key: 'close_date',
        label: 'Close Won Date',
        sortable: false,
        width: '25%',
        render: ({ close_date }: ICompanyDeal) => (
          <StyledCellText2>
            {close_date ? dayjs(dayjs(close_date)).format('MMM DD, YYYY') : ''}
          </StyledCellText2>
        ),
      },
      {
        key: 'deal_stage',
        label: 'Deal Stage',
        sortable: false,
        width: '25%',
        render: ({ deal_stage }: ICompanyDeal) => (
          <StyledCellText2>
            {(deal_stage === 'closedwon' ? 'Closed Won' : deal_stage) || ''}
          </StyledCellText2>
        ),
      },
      {
        key: 'status',
        label: 'Sales Rep report status ',
        sortable: false,
        width: '25%',
        render: ({ status }: ICompanyDeal) => (
          <StyledCellText2>{status}</StyledCellText2>
        ),
      },
    ],
    []
  );

  return (
    <TableContainer sx={{ maxHeight: 260 }}>
      <Table
        data={deals}
        columns={columns}
        idKey="id"
        sx={{
          minWidth: 650,
          '.MuiTableHead-root .MuiTypography-root': {
            color: `${neutrals[500]} !important`,
          },
        }}
        aria-label="simple table"
        size="small"
        stickyHeader
      />
    </TableContainer>
  );
};

export default CompanyDeals;
